import { render, staticRenderFns } from "./toup.vue?vue&type=template&id=4724a5b2&scoped=true&"
import script from "./toup.vue?vue&type=script&lang=js&"
export * from "./toup.vue?vue&type=script&lang=js&"
import style0 from "./toup.vue?vue&type=style&index=0&id=4724a5b2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4724a5b2",
  null
  
)

export default component.exports